// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"116":"e14a8b41","350":"977083c2","353":"54810c53","561":"06deb028","566":"1fd3be46","779":"6f15ae23","844":"3428881b","946":"671dafd1"}[chunkId] + ".css";
};